import React from "react";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";
import { Mail } from "lucide-react";
import { useSiteContent } from "@/lib/siteContent";

const BRAND_LINES = [{
  heading: "About Scentodore",
  body: "Scentodore is a Canadian fragrance house creating modern, French-inspired impressions of iconic luxury scents. Every fragrance is hand-poured at our Canadian atelier and offered directly to customers as 50ml extraits, 10ml pure-oil roll-ons, and 10ml discovery samples.\n\nBrand tagline: Elevate Every Impression.",
}];

const POSITIONING = [{
  heading: "Brand positioning",
  body: "Modern luxury. French-inspired composition, Canadian craftsmanship. High-concentration extraits and pure-oil roll-ons offered direct-to-customer without traditional retail markups. Focused on accessible luxury, honest sourcing, and long-lasting scent design.",
}];

const REQUESTS = [
  { badge: "For editors", title: "Product samples", body: "We’re happy to send product samples for consideration in relevant editorial coverage. Please share the outlet, planned angle, and deadline." },
  { badge: "For writers", title: "Interviews", body: "Founder and creative-team interviews are available on request. Please email with your publication and topic." },
  { badge: "For content", title: "Imagery & assets", body: "Product photography and brand assets can be provided for approved coverage. Ask us for the current media kit." },
];

const NOTE = [{
  heading: "A note on claims",
  body: "We ask media partners not to describe Scentodore as ‘produced in France’ or ‘made in Grasse.’ Our fragrances are French-inspired in composition and hand-poured in Canada. Any award, partnership, or milestone that isn’t independently verified should not be attributed to the brand.",
}];

export default function PressPage() {
  const { site_settings: s } = useSiteContent();
  return (
    <PageShell
      slug="press"
      testid="press"
      eyebrow="Press & Media"
      title="Press kit & media enquiries."
      intro="Writers, editors, and stylists — use the resources below without asking. For samples, interviews, or a specific request, our press desk responds personally."
    >
      <EditableSection slug="press" sectionKey="about" fallback={BRAND_LINES} />
      <EditableSection slug="press" sectionKey="positioning" fallback={POSITIONING} />

      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">What we can share</h2>
        <EditableFeatureGrid slug="press" sectionKey="requests" fallback={REQUESTS} />
      </div>

      <EditableSection slug="press" sectionKey="note" fallback={NOTE} />

      <div className="mt-4 inline-flex items-center gap-3 p-4 rounded-2xl border border-black/10 bg-[#F1ECE4]/40">
        <Mail className="h-4 w-4 text-[#C5A059]" />
        <a href={`mailto:${s.email || "hello@scentodore.com"}?subject=Press%20enquiry`} className="text-sm hover:text-[#C5A059]" data-testid="press-email">
          {s.email || "hello@scentodore.com"}
        </a>
      </div>
    </PageShell>
  );
}
